import script from "./BlogPostView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogPostView.vue?vue&type=script&setup=true&lang=ts"

import "./BlogPostView.vue?vue&type=style&index=0&id=5e9703b7&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9703b7"]])

export default __exports__